module.exports = __webpack_public_path__ + "static/animan_1-13d0bffacb1df647470235bd4654e43f.png";